import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {isEqual} from "lodash"

import id from "@irati/utils/id"
import {connect} from "@irati/store"
import {injectIntl} from "@irati/utils/lang"
import InputWrapper from "./styled/InputWrapper"
import StyledInput from "./styled/Input"
import SearchIcon from "./styled/SearchIcon"
import {setSearchResultsInput} from "../../store/actions/SearchActions"

class SearchInput extends PureComponent {
  static propTypes = {
    search: PropTypes.object,
    setSearchResultsInput: PropTypes.func.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    shouldFocusOnNavSearchClick: PropTypes.bool,
    className: PropTypes.string,
    formatMessage: PropTypes.func.isRequired
  }

  static defaultProps = {
    search: {},
    value: "",
    shouldFocusOnNavSearchClick: false,
    className: null
  }

  constructor(props) {
    super(props)

    this.state = {
      inputHasFocus: false
    }
  }

  componentDidMount() {
    if (this.props.shouldFocusOnNavSearchClick) {
      this.updateSearchResultsInput()
    }
  }

  componentDidUpdate() {
    if (this.props.shouldFocusOnNavSearchClick) {
      this.updateSearchResultsInput()
    }
  }

  updateSearchResultsInput() {
    if (this.props.shouldFocusOnNavSearchClick && this.searchInput && !isEqual(this.searchInput, this.props.search.searchResultsInput)) {
      this.props.setSearchResultsInput(this.searchInput)
    }
  }

  onInputFocus() {
    if (this.props.shouldFocusOnNavSearchClick) {
      this.setState({
        inputHasFocus: true
      })
    }
  }

  onInputBlur() {
    if (this.props.shouldFocusOnNavSearchClick) {
      this.setState({
        inputHasFocus: false
      })
    }
  }

  render() {
    const idNamespace = id("search-input", this.props)

    return (
      <InputWrapper className={this.props.className} id={id("input-wrapper", idNamespace)} hasFocus={this.state.inputHasFocus}>
        <SearchIcon id={id("search-icon", idNamespace)} className="pb-search_small-01" />
        <StyledInput
          id={id("input", idNamespace)}
          type="text"
          onChange={(e) => this.props.onChange(e.target.value)}
          value={this.props.value}
          name="search"
          placeholder={this.props.formatMessage({id: "perks.containers.searchAll.placeholder"})}
          ref={(c) => {
            this.searchInput = c
          }}
          onFocus={() => this.onInputFocus()}
          onBlur={() => this.onInputBlur()}
        />
      </InputWrapper>
    )
  }
}

const mapStateToProps = ({search}) => ({search})

export const mapDispatchToProps = (dispatch) => {
  return {
    setSearchResultsInput: (input) => {
      return dispatch(setSearchResultsInput(input))
    }
  }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SearchInput))
